module.exports = "./img/e30fc5381b7d71e2529e090ea33e067d.jpg";